import { useRecoilValue } from 'recoil';
import dataManagementEntityAtom from 'ProjectManager/DataManagement/Common/recoil/dataManagementEntity/dataManagementEntityAtom';
import dataManagementEntities from 'ProjectManager/DataManagement/Common/constants/dataManagementEntities';
import useUploadProjectFilesFunction from 'ProjectManager/DataManagement/Files/hooks/uploadFilesFunction/useUploadProjectFilesFunction';
import useUploadTemplateFilesFunction from 'ProjectManager/DataManagement/Files/hooks/uploadFilesFunction/useUploadTemplateFilesFunction';

const useUploadFilesFunction = () => {
    const dataManagementEntity = useRecoilValue(dataManagementEntityAtom);

    const dataFromProject = useUploadProjectFilesFunction();
    const dataFromTemplate = useUploadTemplateFilesFunction();

    if (dataManagementEntity === dataManagementEntities.PROJECT) {
        return dataFromProject;
    }

    if (dataManagementEntity === dataManagementEntities.TEMPLATE) {
        return dataFromTemplate;
    }

    return () => {};
};

export default useUploadFilesFunction;
